import { Component } from '@theme/component';

class ProductCustomProperty extends Component {
  connectedCallback() {
    super.connectedCallback?.();

    this._personalizadoCheckbox = this._getPersonalizadoCheckbox();
    this._handleCheckboxChange = this._handleCheckboxChange.bind(this);

    if (this._personalizadoCheckbox) {
      this._personalizadoCheckbox.addEventListener('change', this._handleCheckboxChange);
    }

    this._syncVisibilityWithCheckbox();
    this._updateCharacterCount();
  }

  disconnectedCallback() {
    if (this._personalizadoCheckbox) {
      this._personalizadoCheckbox.removeEventListener('change', this._handleCheckboxChange);
    }

    super.disconnectedCallback?.();
  }

  handleInput() {
    this._updateCharacterCount();
  }

  _getPersonalizadoCheckbox() {
    const productId = this.closest('[data-product-id]')?.dataset.productId;

    if (productId) {
      const scopedCheckbox =
        document.querySelector(
          `product-form-component[data-product-id="${productId}"] input[id^="addon-personalizado-"]`
        ) ??
        document.querySelector(
          `input[id^="addon-personalizado-"]`
        );

      if (scopedCheckbox) return scopedCheckbox;
    }

    return document.querySelector('input[id^="addon-personalizado-"]');
  }

  _handleCheckboxChange() {
    this._syncVisibilityWithCheckbox();
  }

  _syncVisibilityWithCheckbox() {
    const isChecked = !!this._personalizadoCheckbox?.checked;
    this._setVisibility(isChecked);
  }

  _setVisibility(show) {
    this.style.display = show ? 'block' : 'none';

    const inner = this.querySelector('.spacing-style');
    if (inner) {
      inner.style.display = show ? 'block' : 'none';
    }

    const { textInput } = this.refs;
    if (!textInput) return;

    textInput.disabled = !show;

    if (!show) {
      textInput.value = '';
      this._updateCharacterCount();
    }
  }

  _updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    if (!characterCount || !textInput) return;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    characterCount.textContent = template
      .replace('[current]', String(textInput.value.length))
      .replace('[max]', String(textInput.maxLength));
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);